export type GlobalConfigProps = {
  baseAppPath: string;
  nodeEnv: string;
  apiBaseUrl: string;
  cmsBaseUrl: string;
  chanelId: string;
  applicationId: string;
  espaceEntrepriseUrl: string;
  rootId: string;
};

declare global {
  interface Window {
    mgpAuthConfig: GlobalConfigProps;
  }
}

export const baseAppPath =  (window.mgpAuthConfig && window.mgpAuthConfig.baseAppPath) ?  window.mgpAuthConfig.baseAppPath: "/connexion-entreprise";


export const apiBaseUrl =  process.env.REACT_APP_API_AUTH_BASE_URL;

export const cmsBaseUrl =  process.env.REACT_APP_CMS_BASE_URL;

export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

export const espaceEntrepriseUrl =  process.env.REACT_APP_REDIRECT_ESPACE_ENTREPRISE ? process.env.REACT_APP_REDIRECT_ESPACE_ENTREPRISE: "/espace-entreprise/validate";

export const chanelId =  (window.mgpAuthConfig && window.mgpAuthConfig.chanelId) ?  window.mgpAuthConfig.chanelId: "WEB";

export const applicationId =  (window.mgpAuthConfig && window.mgpAuthConfig.applicationId) ?  window.mgpAuthConfig.applicationId: "EE";

export const rootId = (window.mgpAuthConfig && window.mgpAuthConfig.rootId) ?  window.mgpAuthConfig.rootId: "root";